// Official document catalog — summarize + link, never reproduce full PDFs.
// Source: docs/knowledge/official-documents.yaml
import { LAST_VERIFIED } from './officialSources';

export const OFFICIAL_DOCUMENTS = [
	{
		id: 'tourist-visa-online-form',
		title: 'Online Tourist Visa Application',
		authority: 'Department of Immigration',
		url: 'http://nepaliport.immigration.gov.np/',
		type: 'online_form',
		summary: 'Complete before arrival; print barcode receipt (valid 15 days). Required for faster airport visa processing.',
		lastVerified: LAST_VERIFIED,
	},
	{
		id: 'tourist-visa-info',
		title: 'Tourist Visa Information',
		authority: 'Department of Immigration',
		url: 'https://www.immigration.gov.np/en/page/tourist-visa',
		type: 'web_page',
		summary: 'Official fees (15/30/90 days), on-arrival process, extension rules, gratis visa categories.',
		lastVerified: LAST_VERIFIED,
	},
	{
		id: 'visa-on-arrival',
		title: 'Visa on Arrival',
		authority: 'Department of Immigration',
		url: 'https://www.immigration.gov.np/en/page/visa-on-arrival',
		type: 'web_page',
		summary: 'Eligibility, restricted nationalities, entry points including TIA and land borders.',
		lastVerified: LAST_VERIFIED,
	},
	{
		id: 'tia-arrival-info',
		title: 'TIA Arrival Information',
		authority: 'Immigration Office, Tribhuvan International Airport',
		url: 'https://tia.immigration.gov.np/en/page/arrival-information',
		type: 'web_page',
		summary: 'Arrival card, passport requirements, on-arrival visa counters (5–12), Indian nationals, visa gratis categories.',
		lastVerified: LAST_VERIFIED,
	},
	{
		id: 'tia-faq',
		title: 'TIA Immigration FAQ',
		authority: 'Immigration Office, TIA',
		url: 'https://tia.immigration.gov.np/en/page/faq',
		type: 'web_page',
		summary: 'Processing times, VOA-ineligible nationalities, visa types, extension overview.',
		lastVerified: LAST_VERIFIED,
	},
	{
		id: 'ntb-tourist-visa',
		title: 'Nepal Tourism Board — Tourist Visa',
		authority: 'Nepal Tourism Board',
		url: 'https://ntb.gov.np/plan-your-trip/before-you-come/tourist-visa',
		type: 'web_page',
		summary: 'Traveler-friendly visa overview, documents, payment methods at entry points.',
		lastVerified: LAST_VERIFIED,
	},
	{
		id: 'arrival-departure-info',
		title: 'Arrival & Departure Information',
		authority: 'Department of Immigration',
		url: 'https://immigration.gov.np/en/page/arrival-departure-information-1',
		type: 'web_page',
		summary: 'General entry and exit procedures for Nepal.',
		lastVerified: LAST_VERIFIED,
	},
	{
		id: 'customs-home',
		title: 'Department of Customs',
		authority: 'Government of Nepal',
		url: 'https://www.customs.gov.np/',
		type: 'web_page',
		summary: 'Import/export rules, duty, declaration requirements for goods including drones and valuables.',
		lastVerified: LAST_VERIFIED,
	},
	{
		id: 'archaeology-export',
		title: 'Department of Archaeology',
		authority: 'Government of Nepal',
		url: 'https://www.doa.gov.np/',
		type: 'web_page',
		summary: 'Export certificates for antiques and cultural objects over 100 years old.',
		lastVerified: LAST_VERIFIED,
	},
	{
		id: 'caan-home',
		title: 'Civil Aviation Authority of Nepal',
		authority: 'CAAN',
		url: 'https://www.caan.gov.np/',
		type: 'web_page',
		summary: 'Aviation regulations, drone rules, airport operations.',
		lastVerified: LAST_VERIFIED,
	},
	{
		id: 'dnpwc-home',
		title: 'Department of National Parks and Wildlife Conservation',
		authority: 'DNPWC',
		url: 'https://dnpwc.gov.np/',
		type: 'web_page',
		summary: 'National park entry permits, regulations, protected area fees.',
		lastVerified: LAST_VERIFIED,
	},
	{
		id: 'ntnc-acap',
		title: 'NTNC — Annapurna Conservation Area',
		authority: 'National Trust for Nature Conservation',
		url: 'https://ntnc.org.np/',
		type: 'web_page',
		summary: 'ACAP permit information for Annapurna region treks.',
		lastVerified: LAST_VERIFIED,
	},
	{
		id: 'ntc-gsm-prepaid',
		title: 'NTC GSM Prepaid Service & Tariffs',
		authority: 'Nepal Telecom',
		url: 'https://www.ntc.net.np/services/gsm-prepaid-service',
		type: 'web_page',
		summary: 'Official prepaid SIM tariffs, data packages, registration requirements.',
		lastVerified: LAST_VERIFIED,
	},
	{
		id: 'ntc-wifi',
		title: 'NT WiFi Hotspot Locations',
		authority: 'Nepal Telecom',
		url: 'https://www.ntc.net.np/services/nt-wifi',
		type: 'web_page',
		summary: 'NT WiFi available at Kathmandu Airport International terminal — subscribe via SMS to 1416.',
		lastVerified: LAST_VERIFIED,
	},
	{
		id: 'ntc-esim',
		title: 'NT eSIM Portal',
		authority: 'Nepal Telecom',
		url: 'https://esim.ntc.net.np/',
		type: 'online_form',
		summary: 'eSIM application for compatible phones; requires WiFi to activate and download profile.',
		lastVerified: LAST_VERIFIED,
	},
	{
		id: 'ncell-home',
		title: 'Ncell — Packages & Services',
		authority: 'Ncell Axiata',
		url: 'https://www.ncell.com.np/en/individual',
		type: 'web_page',
		summary: 'Tourist prepaid packages, data packs, recharge options.',
		lastVerified: LAST_VERIFIED,
	},
	{
		id: 'unesco-nepal',
		title: 'UNESCO World Heritage — Nepal',
		authority: 'UNESCO',
		url: 'https://whc.unesco.org/en/statesparties/np',
		type: 'web_page',
		summary: 'Official UNESCO site listings and cultural heritage context for Nepal.',
		lastVerified: LAST_VERIFIED,
	},
	{
		id: 'embassy-berlin',
		title: 'Embassy of Nepal, Berlin — Visa',
		authority: 'Ministry of Foreign Affairs, Nepal',
		url: 'https://de.nepalembassy.gov.np/pages/visa-1/',
		type: 'web_page',
		summary: 'German and EU nationals: VOA eligible; embassy issues tourist, diplomatic, official visas. VOA-ineligible country list cited.',
		lastVerified: LAST_VERIFIED,
	},
	{
		id: 'ntb-plan-trip',
		title: 'NTB Plan Your Trip',
		authority: 'Nepal Tourism Board',
		url: 'https://ntb.gov.np/plan-your-trip',
		type: 'web_page',
		summary: 'Official tourism board travel planning resources, brochures, and destination information.',
		lastVerified: LAST_VERIFIED,
	},
	{
		id: 'immigration-extension',
		title: 'Visa Extension Information',
		authority: 'Department of Immigration',
		url: 'https://www.immigration.gov.np/en/page/tourist-visa',
		type: 'web_page',
		summary: 'Extension fees, maximum stay, overstay fines — same page as tourist visa regulations.',
		lastVerified: LAST_VERIFIED,
	},
];
